<script setup>
// eslint-disable-next-line no-undef
const props = defineProps({
  title:{
    type: String,
    default: 'Открыть окно'
  },
  icon:{
    type: String,
    default: 'mdi:information-outline'
  },
})
// eslint-disable-next-line no-undef,no-unused-vars
const emit = defineEmits(['click'])
const click = () => emit('click')
</script>
<template>
  <span
      class="btn-link float-left"
      @click="click"
  >
    <v-icon class="nav-icon" :icon="props.icon"></v-icon>
    <span class="btn-label"><strong>{{ props.title }}</strong></span>
  </span>
  <div class="clearfix"></div>
</template>